/**
 * @desc PDA-提交拣货数据
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.PickDetailBoxRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/pickMaster/pick`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
